import type * as zod from 'zod';

import Step from '../Step';

import Arguments from './Arguments';
import Variables from './Variables';

type Arguments = zod.infer<typeof Arguments>;

type Variables = zod.infer<typeof Variables>;

/**
 * Inert placeholder for a step that was suppressed in the routine editor.
 *
 * The routine→runner converter (`convertRoutineToRoutineRunnerSchema`) rewrites
 * every effectively-suppressed step to this kind. That lets the runner keep the
 * full step tree — ids and nesting intact — without having to convert the
 * suppressed step's real, possibly-unconfigured configuration (which would
 * throw). It accepts substeps so a suppressed decorator's children (themselves
 * effectively suppressed) become `Suppressed` steps too, preserving structure.
 *
 * It never executes: `RoutineRunner.playSteps` skips suppressed steps before
 * play, so the inherited no-op `_play` is never reached. `areSubstepsRequired`
 * is false because a suppressed decorator may legitimately be empty.
 */
export default class SuppressedStep extends Step<Arguments, Variables> {
  public static areSubstepsRequired = false;

  public static Arguments = Arguments;

  public static Variables = Variables;

  public substeps: Array<Step<object, object>> = [];

  protected initializeVariableState(): void {
    this.variables = {};
  }
}
